import React, { useState } from "react";
import { useLang } from "@/i18n/LanguageContext";
import { NAV } from "@/constants/testIds";
import { ChevronDown, Check } from "lucide-react";

export default function LanguageSwitcher() {
  const { lang, setLang, langs } = useLang();
  const [open, setOpen] = useState(false);
  const current = langs.find((l) => l.code === lang) || langs[0];

  return (
    <div className="relative" data-testid={NAV.langSwitch}>
      <button
        onClick={() => setOpen((v) => !v)}
        onBlur={() => setTimeout(() => setOpen(false), 120)}
        className="flex items-center gap-2 px-3 py-2 font-mono text-xs uppercase tracking-[0.18em] text-[#0a0a0a] hover:text-[#ff006e] transition-colors border border-transparent hover:border-[#0a0a0a]"
        aria-haspopup="listbox"
        aria-expanded={open}
      >
        {/* Bandera como imagen (SVG): los emoji no se dibujan igual en todos los sistemas */}
        <img src={`/assets/flags/${current.code}.svg`} alt="" className="w-4 h-3 object-cover" />
        <span>{current.label}</span>
        <ChevronDown size={12} className={open ? "rotate-180 transition-transform" : "transition-transform"} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 min-w-[180px] bg-white border border-[#0a0a0a] shadow-[6px_6px_0_0_rgba(10,10,10,1)] z-50">
          {langs.map((l) => (
            <button
              key={l.code}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => {
                setLang(l.code);
                setOpen(false);
              }}
              data-testid={NAV.langOption(l.code)}
              className={`w-full text-left flex items-center gap-3 px-4 py-3 font-mono text-xs uppercase tracking-[0.18em] hover:bg-[#f5f5f5] ${
                l.code === lang ? "text-[#ff006e]" : "text-[#0a0a0a]"
              }`}
            >
              <img src={`/assets/flags/${l.code}.svg`} alt="" className="w-4 h-3 object-cover" />
              <span className="flex-1">{l.name}</span>
              {l.code === lang && <Check size={12} />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
